
import React from 'react';
import ProfileFeature from '../features/profile/Profile';

const ProfilePage: React.FC = () => {
    return <ProfileFeature />;
};

export default ProfilePage;
